"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const react_1 = tslib_1.__importStar(require("react"));
const react_2 = require("@osmosys/react");
exports.EmailCanvasPreviewViewInner = ({ html }) => {
    const previewRef = react_1.useRef(null); // Ref for the container of the preview
    const [scrollPosition, setScrollPosition] = react_1.useState(0);
    // Function to handle scroll
    const handleScroll = () => {
        if (previewRef.current) {
            setScrollPosition(previewRef.current.scrollTop);
        }
    };
    // Function to add event listener
    const addScrollEventListener = () => {
        if (previewRef.current) {
            previewRef.current.addEventListener('scroll', handleScroll);
        }
        else {
            // Retry after a short delay if the ref is not set
            setTimeout(addScrollEventListener, 100);
        }
    };
    // Capture the current scroll position before update
    react_1.useEffect(() => {
        addScrollEventListener();
        return () => {
            if (previewRef.current) {
                previewRef.current.removeEventListener('scroll', handleScroll);
            }
        };
    }, []);
    // Restore the scroll position after update
    react_1.useEffect(() => {
        if (previewRef.current) {
            previewRef.current.scrollTop = scrollPosition;
        }
    }, [html]);
    return (react_1.default.createElement(react_2.OsmosysDiv, { osysName: "EmailCanvasPreviewView", flexColFilled: true },
        react_1.default.createElement(react_2.OsmosysFlexFrame.Col, { osysName: "EmailCanvasPreviewView.Inner", flexColFilled: true, className: "position-relative", ref: previewRef },
            react_1.default.createElement(react_2.OsmosysIframe, { className: "flex-grow-1 mb-0 w-100 h-100 bg-white border-0" }, html))));
};
//# sourceMappingURL=Inner.js.map